import React, { useState, useEffect, useRef, use } from "react";
import axios from "axios";
import TableView1 from "./TableView1";
import TableView2 from "./TableView2";

function Dashboard({ handleLogout, tableRef }) {
  const [email, setEmail] = useState("");
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const [input3, setInput3] = useState("");
  const [input4, setInput4] = useState("");
  const [calculationResult, setCalculationResult] = useState("");
  const [error, setError] = useState("");

  const resultSectionRef = useRef(null);

  useEffect(() => {
    const userEmail = localStorage.getItem("email");
    if (userEmail) {
      setEmail(userEmail);
    }
  }, []);

  useEffect(() => {
    setCalculationResult("");
  }, [input1, input2, input3, input4]);

  const handleCalculate = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "/calculate",
        {
          input1: Number(input1),
          input2,
          input3: Number(input3),
          input4,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.message) {
        setCalculationResult(response?.message);
      } else {
        setCalculationResult(response?.data?.result);
      }
      if (resultSectionRef.current) {
        resultSectionRef.current.scrollIntoView({ behavior: "smooth" });
      }
    } catch (error) {
      setCalculationResult("");
      setError(error.response.data.message);
    }
  };

  useEffect(() => {
    let timeout;
    if (error === "Failed to authenticate token.") {
      timeout = setTimeout(() => {
        handleLogout();
      }, 3000);
    }
    return () => clearTimeout(timeout);
  }, [error]);

  return (
    <div className="dashboard-container">

      <div className="calculation-card">
        <div className="card-header">
          <img
            className="img-logo"
            src="/Casagrand-Logo1.webp"
            alt="logo"
            width={200}
          />
          <h2 className="padding-10">Land Info and Calculation</h2>
        </div>

        <div className="input-display-flex">
          <div className="input-group">
            <label className="input-label">Sales Price</label>
            <input
              type="number"
              className="calc-input"
              placeholder="Enter sales price"
              value={input1}
              onChange={(e) => setInput1(e.target.value)}
            />
          </div>

          <div className="input-group">
            <label className="input-label">Zone</label>
            <select
              value={input2}
              onChange={(e) => setInput2(e.target.value)}
              className="calc-select"
            >
              <option value="">Select Zone</option>
              <option value="CHENNAI">Chennai</option>
              <option value="BANGALORE">Bangalore</option>
              <option value="HYDERABAD">Hyderabad</option>
              <option value="PUNE">Pune</option>
              <option value="COIMBATORE">Coimbatore</option>
              <option value="DELHI-NCR">Delhi-NCR</option>
            </select>
          </div>

          <div className="input-group">
            <label className="input-label">FSI</label>
            <input
              type="number"
              step="0.1"
              className="calc-input"
              placeholder="Enter FSI value"
              value={input3}
              onChange={(e) => setInput3(e.target.value)}
            />
          </div>

          <div className="input-group">
            <label className="input-label">Type of Development</label>
            <select
              value={input4}
              onChange={(e) => setInput4(e.target.value)}
              className="calc-select"
            >
              <option value="">Select Development Type</option>
              <option value="VILLA">Villa</option>
              <option value="LOWRISE">Low Rise</option>
              <option value="MSB">MSB</option>
            </select>
          </div>
        </div>

        <button
          onClick={handleCalculate}
          className="calculate-btn"
          disabled={!input1 || !input2 || !input3 || !input4}
        >
          🧮 Calculate Land Values
        </button>

        {error && error == "Failed to authenticate token." && (
          <div className="session-error">
            User Session Expired, Signin again
          </div>
        )}

        {calculationResult && (
          <div>
            <div ref={resultSectionRef}>
              <div className="card-header dis-none">
                <img
                  className="img-logo"
                  src="/Casagrand-Logo1.webp"
                  alt="logo"
                  width={200}
                />
                <h2 className="padding-10">Land Info and Calculation</h2>
                {/* <p>Enter the required parameters to calculate land values</p> */}
              </div>
              <div className="padding-20">
                <table class="table-view">
                  <thead>
                    <tr>
                      <th className="table-head-font width-25p">Sales Price</th>
                      <th className="table-head-font width-25p">zone</th>
                      <th className="table-head-font width-25p">FSI</th>
                      <th className="table-head-font width-25p">
                        Type of Development
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="ft-w-500 width-25p">{input1}</td>
                      <td className="ft-w-500 width-25p">{input2}</td>
                      <td className="ft-w-500 width-25p">{input3}</td>
                      <td className="ft-w-500 width-25p">{input4}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <TableView2 calculationResult={calculationResult} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Dashboard;
